import Immutable from "seamless-immutable";
import DEF_TRANSLATIONS from "./translations.default";

export default Immutable({
  loading: false,
  error: undefined,
  translations: DEF_TRANSLATIONS,
  currentLocale: undefined,
});
